module.exports = __webpack_public_path__ + "img/left-bg.26c21782.png";